import { AlmanacFile as Article } from 'types'
import { ImportedArticle } from 'api/clients/ImportClient'

export enum SourceType {
  Main = 'main',
  Notion = 'notion',
  Confluence = 'confluence',
  GoogleDocs = 'gdocs',
  GoogleSlides = 'googleslides',
  GoogleSheets = 'googlesheets',
  Figma = 'figma',
  Airtable = 'airtable',
  Canva = 'canva',
}

export enum ImportStateType {
  Cancelling = 'cancelling',
  Import = 'import',
  Importing = 'importing',
  Imported = 'imported',
  HandbookOptions = 'options',
}

export enum FileImportStatus {
  Initiated = 'initiated',
  Uploading = 'uploading',
  Processing = 'processing',
  PartiallySuccessful = 'partially_successful',
  Successful = 'successful',
  Failed = 'failed',
  Cancelled = 'cancelled',
}

export interface FileImport {
  index: number
  originalFile: File
  source: string
  status: FileImportStatus
  abortController: AbortController
  import_id?: number
  errorMsg?: string
  topLevelFolders?: string[] | undefined
  articles: ImportedArticle[]
}

export interface ImportArticle extends Article {
  import_id: number
  filename: string
  status: string
  created_at: string
  location: {
    key: string
    name: string
  }
}

export interface ImportContainer {
  id: number
  filename: string
  status: string
  created_at: string
  articles: ImportArticle[]
}

export interface ImportListing {
  title: string
  containers: ImportContainer[]
}
